/**
 * Who may be booked for a service: the team of its category.
 *
 * Every service arrives with `resourceIds` — the resources its category's team
 * is made of. Empty means anyone, which is what every service without a
 * category, and every category nobody has been assigned to, carries. The
 * server refuses a booking outside the team; these helpers are how a form
 * avoids offering one in the first place.
 */

/** Whether `resourceId` may take a booking for `service`. */
export const canServe = (service, resourceId) => {
  const team = service?.resourceIds;
  if (!team || team.length === 0) return true;
  return team.includes(Number(resourceId));
};

/** The resources a form should offer for `service` — all of them until one is chosen. */
export const resourcesForService = (resources, service) =>
  service ? resources.filter((resource) => canServe(service, resource.id)) : resources;

/** The services a form should offer for `resourceId` — all of them until one is chosen. */
export const servicesForResource = (services, resourceId) =>
  resourceId ? services.filter((service) => canServe(service, resourceId)) : services;
